import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IFiCheckboxItem } from '@fi-shared/fi-checkbox2/fi-checkbox2';

@Component({
    selector: 'fi-checkbox2-list',
    template: `
        <div class="NoSelect">
          <fi-checkbox2
            [item]="{ name: header }"
            [ngModel]="ngModel"
            class="CcmCheckboxListHeader"
            #headerCheckbox
          ></fi-checkbox2>
        
          <div class="CcmCheckBoxListItems">
            @for (item of items; track item) {
              <div class="itemParent">
                <fi-checkbox2
                  [item]="item"
                  [disableIds]="disableIds"
                  [ngModel]="ngModel"
                  (ngModelChange)="onCheckedItemsChanged($event)"
                ></fi-checkbox2>
              </div>
            }
          </div>
        </div>
        `,
    styleUrls: ['./fi-checkbox2-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiCheckbox2ListComponent,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiCheckbox2ListComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiCheckbox2ListComponent extends ControlValueAccessorValidatorBase<number[]> implements OnInit, OnChanges {
    @Input() header: string = 'Areas';
    @Input() items: IFiCheckboxItem[];
    @Input() disableIds: number[];

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges): void {}

    onCheckedItemsChanged($event) {}
}
